import Link from 'next/link';
// import "./style.scss";
import Store from '../../../store';
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector, useDispatch } from "react-redux";
import { openMobileInbox } from './../../../store/actions/messages';

function AppFooter() {
	//Starting // Need User Data....
	const { userAuth } = Store.getState();
	const dispatch = useDispatch();
	userAuth.avatar = userAuth.avatar || `${process.env.IMAGES_BASE_URL}/static-content/empty-profile.png.webp`;
	//Ending // Need User Data....

	const { avatar, unreadMsgCount } = useSelector((state) => ({
		avatar: state.userAuth.avatar,
		unreadMsgCount: state.messagesReducer.unreadMsgCount
	}), shallowEqual);

	const [profileImage, setProfileImage] = useState(`${process.env.IMAGES_BASE_URL}/static-content/empty-profile.png.webp`);
	const [href, setHref] = useState("");

	useEffect(() => {
		setHref(window.location.href);
		setProfileImage(avatar)
	}, []);

	useEffect(() => {
		setProfileImage(avatar)
	}, [avatar]);

	const [activeBtn, setActiveBtn] = useState();

	return (
		<div className="footer-nav mobile-nav">
			<ul>
				<li className={(href.indexOf("home") > -1) ? "active" : ""}>
					<Link href="/home" as="/home">
						<a>
							<span className="navimg">
								{/* <img src={(href.indexOf("home") > -1) ? `${process.env.IMAGES_BASE_URL}/static-content/home-icon.png.webp` : "/icons/home.png"}></img> */}
								<img src="/icons/noun_Mosque_2939971.svg" />
							</span>
							<span className="text">Home</span>
						</a>
					</Link>
				</li>
				<li className={(href.indexOf("chat") > -1) ? "active" : ""}>
					<Link href="/chat" as="/chat">
					<a >
						<span className="navimg">
							{/* <img src={(href.indexOf("chat") > -1) ? "/icons/message-active.png" : "/icons/msg-inactive.png"}></img> */}
							<img src="/icons/Subtraction.svg" />
							{
								unreadMsgCount > 0 &&
								<div className="msg-unread-count">{unreadMsgCount}</div>
							}
						</span>
						<span className="text">Chat</span>
					</a>
					</Link>
				</li>
				<li className={(href.indexOf("classes") > -1) ? "active" : ""}>
					<Link href="/classes" as="/classes">
						<a>
							<span className="navimg">
								{/* <img src={(href.indexOf("classes") > -1) ? "/icons/class-f.png" : `${process.env.IMAGES_BASE_URL}/static-content/clase-icon.png.webp`}></img> */}
								<img src="/icons/noun_study_2717879.svg" />
							</span>
							<span className="text"><nobr>On-Demand</nobr></span>
						</a>
					</Link>
				</li>
				<li className={(href.indexOf("network") > -1) ? "active" : ""}>
					<Link href="/network" as="/network">
						<a>
							<span className="navimg">
								{/* <img src={(href.indexOf("network") > -1) ? "/icons/network-f.png" : `${process.env.IMAGES_BASE_URL}/static-content/network-icon.png.webp`}></img> */}
								<img src="/icons/Network.svg" />
							</span>
							<span className="text">Network</span>
						</a>
					</Link>
				</li>
				<li className={(href.indexOf("profile") > -1) ? "active" : ""}>
					<Link href="/profile" as="/profile">
						<a>
							<span className="navimg"><img src={profileImage}></img></span>
							<span className="text">Profile</span>
						</a>
					</Link>
				</li>
			</ul>
		</div>
	);
}

export default AppFooter;
